import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user.model';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthInterceptorService } from '../../../services/interceptors/auth-interceptor.service';
import { ToastNotificationService } from '../../../services/toast-notification.service';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton]
})
export class AccountComponent implements OnInit {
  user: User | null = null;
  email: string = '';
  public accountFg: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authInterceptorService: AuthInterceptorService,
    private toastNotificationService: ToastNotificationService
  ) {
  }

  ngOnInit(): void {
    this.accountFg = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]]
    });
    this.loadUserData();
  }

  loadUserData(): void {
    const userData = localStorage.getItem('user');

    if (userData) {
      this.user = JSON.parse(userData);
      this.accountFg.setValue({
        first_name: this.user?.first_name || '',
        last_name: this.user?.last_name || '',
        email: this.user?.email || ''
      });
    }
  }


  saveChanges(): void {
    const values = this.accountFg.value;
    this.authInterceptorService.updateCurrentUser(values)
      .subscribe(
        () => {
          // Update the user data in localStorage
          if (this.user) {
            this.user.first_name = values.first_name;
            this.user.last_name = values.last_name;
            this.user.email = values.email;
            localStorage.setItem('user', JSON.stringify(this.user));
          }
          this.toastNotificationService.showNotification({ type: 'success', message: 'User profile updated Successfully' });
          this.accountFg.markAsPristine();
        },
        () => {
          this.toastNotificationService.showNotification({ type: 'error', message: 'Error updating profile' });
        }
      );
  }
}
